<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/company/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>Mục đích doanh nghiệp, triết lý doanh nghiệp, chính sách nghề nghiệp<!--企業宗旨、企業理念、事業方針--></h1>
        </div>
      </header>
      <HeaderNav activeLink="intro" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">Mục đích của công ty<!--企業宗旨--></h2>
            <div>
              <p>
                Kể từ khi thành lập vào năm 1997, Fudizhi rất coi trọng sự kết nối giữa con người với nhau.
                <!--富地滋自1997年創業以來，最重視的就是人與人之間的連繫。 -->
                <br />
                Thông qua tiếp xúc trực tiếp với mọi người và truyền đạt khái niệm sức khỏe về dinh dưỡng axit nucleic,
                <!--藉由面對面 (Face to Face)的直接與人接觸並且傳達核酸營養的健康概念， -->
                <br />
                Để tăng cường sự kết nối lẫn nhau, khắc sâu tấm lòng nghĩ đến người khác, từ đó kết hợp sự phấn khích và tin tưởng của mọi người.
                <!--以加強彼此的連繫、深化為他人著想的心，進而結合眾人的感動與信賴。-->
              </p>
              <p>
                FORDAYS = Tích lũy sức khỏe và mang lại cho bạn một cuộc sống tươi đẹp.<!--累積您的健康，帶給您美麗的人生。--> 
                <br />
                Tên Công ty Fudizi tượng trưng cho việc làm phong phú thêm cuộc sống của bạn và hướng tới hạnh phúc với một tinh thần giàu có và một cơ thể khỏe mạnh.
                <!--富地滋公司的名稱代表著以富裕的心靈和健康的身體，豐富您的人生邁向幸福。-->
                <br />
                Chúng tôi sử dụng điều này làm nền tảng để theo đuổi sức khỏe và tạo ra sự sống axit nucleic nhằm tạo ra một môi trường lành mạnh tự nhiên mới.
                <!--我們以此為基石致力追求健康，並且創造核酸生活，打造一個全新自然的健康環境。-->
              </p>
              <p>
                Futizhi đã thành lập 7 hội trường trên khắp Nhật Bản và liên tiếp bổ sung thêm nhiều cơ sở như trung tâm điều dưỡng và quán cà phê.
                <!--富地滋在日本全國各地設立7大會館，並且陸續增設保養所、咖啡館等多處設施，-->
                <br />
                Một mặt, nó mang lại cho các thành viên cơ hội giao tiếp với nhau và hiểu biết sâu sắc hơn về nghề nghiệp của họ.
                <!--一方面提供給廣大會員們相互交流分享、深入了解事業機會， -->
                <br />
                Một mặt, họ làm sâu sắc thêm mối liên kết tình cảm giữa nhau và thực sự đạt được khoảng cách mặt đối mặt bằng không.
                <!--一方面加深彼此之間的感情羈絆，真正達到 Face to Face 零距離。-->
                <br />
                Ngoài ra, chúng tôi có đội ngũ nghiên cứu và phát triển chuyên nghiệp luôn nỗ lực đổi mới và thay đổi, đi đầu trong các xu hướng của thời đại. Chúng tôi cũng có trung tâm quản lý chất lượng và nhà máy riêng.
                <!--此外，擁有專業的研究開發團隊求新求變，走在時代潮流的先端；更設立品質管理中心與自家工場，-->
                <br />
                Tuân thủ các nguyên tắc "an toàn, bảo mật và tin cậy", chúng tôi thực hiện đảm bảo chất lượng toàn diện và quản lý thống nhất.
                <!--秉持著「安全、安心、信賴」的原則，進行全面性的品質保證與一元化管理。-->
              </p>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">Triết lý doanh nghiệp<!--企業理念--></h2>
            <div>
              <h2 class="section-title">
                Thương hiệu axit nucleic đầu tiên<!--核酸第一品牌--> <br />
                Triết lý của công ty lấy tình yêu làm điểm khởi đầu, quan tâm là trách nhiệm và giúp đỡ người khác là sứ mệnh của chúng tôi
                <!--以愛為出發點、以關懷為己任、以助人為志業的企業理念-->
              </h2>
              <p>
                Fudizhi cam kết nghiên cứu liên quan đến dinh dưỡng tế bào và axit nucleic. Ngoài sáu chất dinh dưỡng chính mà chúng ta biết là protein, 
                lipid, carbohydrate, vitamin, khoáng chất và chất xơ, axit nucleic còn được gọi là chất dinh dưỡng thứ bảy và đã thu hút nhiều sự chú ý.
                <!--富地滋致力於細胞營養及核酸進行相關的研究。除了我們所認知的蛋白質、脂質、醣類、維生素、礦物質、食物纖維六大營養素外，核酸則是被稱為第7營養素而備受矚目。-->
              </p>
              <p>
                Năm 2004, Fudizi thành lập chi nhánh nước ngoài đầu tiên tại Đài Loan, bén rễ và phát triển, đồng thời thành lập các câu lạc bộ chỉ dành cho thành viên ở Đài Bắc, 
                Đài Trung và Cao Hùng. Mục đích là sử dụng công nghệ y tế tiên tiến nhất của Nhật Bản để tạo ra một kỷ nguyên mới cho thương hiệu axit nucleic của Đài Loan, 
                đồng thời triển khai và tích hợp khái niệm sống lành mạnh về dinh dưỡng axit nucleic vào cuộc sống hàng ngày của mọi người.
                <!--2004年，富地滋在台灣成立第一個海外分公司，落地生根成長，並且於台北、台中、高雄均設立會員專用會館。目的就是要透過日本最先端的健康科技，開創台灣核酸品牌新紀元，將核酸營養的健康生活理念貫徹並融入到每個人的日常當中。-->
              </p>
              <p>
                Chúng tôi cung cấp các sản phẩm chất lượng cao và không ngừng phát triển, hệ thống quản lý kinh doanh được thiết kế riêng cho các nhu cầu khác nhau, 
                nhận thức giá trị cá nhân, kích thích tiềm năng vô hạn, đồng thời tích cực mở rộng và kết nối các thị trường quốc tế ở nước ngoài để đưa bình minh 
                của cuộc sống ra thế giới.
                <!--我們提供優質且不斷進化的產品，量身訂做不同需求的事業經營系統，實現個人自我價值，激發無限潛能，並積極拓展連結海外國際市場，為全球注入生命的曙光。-->
              </p>
              <p>
                Dựa trên quan điểm phát triển quản lý bền vững và định hướng con người, Taiwan Fortune đã thiết lập một thương hiệu ổn định và mạnh mẽ để dẫn đầu thị trường. 
                Công ty cũng hy vọng xây dựng một gia đình ấm áp, nơi mỗi người cùng đóng góp và cùng đạt được thành tựu, dẫn dắt mọi người tạo nên một gia đình lành mạnh. 
                và tương lai thịnh vượng, viết thêm những chương truyện cảm động.
                <!--台灣富地滋以人為本，永續經營的發展理念為根基，建立穩固強大的品牌引領市場，更期許建立一個有溫度的大家庭，彼此互相付出、互相成就，帶領每一個人開創健康致富的人生未來，寫下更多感動的故事篇章。-->
              </p>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">Chính sách kinh doanh<!--事業方針--></h2>
            <div>
              <div class="company-intro-list">
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_1.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    Cam kết nghiên cứu và phát triển học thuật liên quan đến axit nucleic cũng như tiết lộ thông tin
                    <!--致力於核酸相關的學術研究與開發，以及情報公開-->
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_2.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    Sản xuất và phát triển sản phẩm chất lượng cao
                    <!--製造並開發高品質產品-->
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_3.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    Cung cấp thông tin sức khỏe chính xác
                    <!--提供正確的健康情報-->
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_4.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    Theo đuổi sự an toàn và bảo mật của sản phẩm
                    <!--追求產品的安全、安心-->
                  </div>
                </div>
                <div class="company-intro-list-item">
                  <div class="company-intro-list-item-icon">
                    <img
                      :src="require('@/assets/public/images/company/c_5.png')"
                      alt=""
                      class="w-100"
                    />
                  </div>
                  <div class="company-intro-list-item-title">
                    Nâng cao nhận thức xã hội về axit nucleic và truyền tải các hoạt động khai sáng liên quan đến sức khỏe
                    <!--提高核酸的社會認知度，傳達與健康相關的啟發活動-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/CompanyHeaderNav";
export default {
  name: "CompanyIntroScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
